<template>
  <div class="relative z-[10]">
    <div
      v-if="value"
      class="fixed inset-0 backdrop-blur-sm"
      @click="closeMenu"
    ></div>
    <transition
      enter-active-class="transform duration-300"
      enter-from-class="opacity-0 translate-x-full"
      enter-to-class="opacity-100 translate-x-0"
      leave-active-class="transform duration-300"
      leave-from-class="opacity-100 translate-x-0"
      leave-to-class="opacity-0 translate-x-full"
    >
      <div
        v-if="value"
        class="title fixed bottom-0 right-0 top-0 z-10 w-full bg-gray-lighten3 pb-[4rem] pt-20 text-slate"
        @click.stop
      >
        <div
          class="absolute left-0 top-4 w-full border-b-[1px] border-b-gray-lighten1"
        >
          <div class="flex w-full items-center justify-between pl-6 pr-3">
            <span
              v-if="!activeCategory"
              class="text-base font-bold uppercase text-slate"
            >
              {{ $t('menu') }}
            </span>
            <div v-else class="flex items-center" @click="closeCategory">
              <UiIcon icon="chevronLeft" class="mr-4" />
              <span
                class="text-base font-bold uppercase tracking-[.12em] text-slate"
              >
                {{ activeCategory.name }}
              </span>
            </div>
            <button aria-label="close" class="p-3" @click="closeMenu">
              <UiIcon icon="close" class="h-6 w-6" />
            </button>
          </div>
        </div>

        <ul v-if="!activeCategory" class="flex flex-col">
          <HeaderMainMenuMobileItem
            v-for="menuItem in menu"
            :key="menuItem.id"
            :menu-item="menuItem"
            @open-category="openCategory(menuItem)"
            @close-menu="closeMenu"
          />
        </ul>

        <ul v-else class="flex flex-col tracking-[.12em]">
          <HeaderMainMenuMobileItem
            v-for="menuItem in activeCategory.children"
            :key="menuItem.id"
            :menu-item="menuItem"
            :is-inner-category="true"
            :are-last-children="areLastChildren"
            @open-category="openCategory(menuItem)"
            @close-menu="closeMenu"
          />
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import HeaderMainMenuMobileItem from '@/domains/menus/components/HeaderMainMenuMobileItem.vue';

interface Props {
  value?: boolean;
  menu?: any[];
}
interface Emits {
  (e: 'toggle-menu'): void;
}

withDefaults(defineProps<Props>(), {
  value: false,
  menu: () => [],
});
const emit = defineEmits<Emits>();

const activeCategory = ref<any | null>(null);
const activeCategoryList = ref<any[]>([]);

const openCategory = (category: any) => {
  activeCategoryList.value.push(category);
  activeCategory.value = category;
};

const closeCategory = () => {
  if (activeCategoryList.value.length) {
    const lastIndex = activeCategoryList.value.length - 1;
    // Delete last category
    activeCategoryList.value.pop();
    activeCategory.value = activeCategoryList.value[lastIndex - 1];
  } else {
    activeCategory.value = null;
  }
};

const closeMenu = () => {
  activeCategory.value = null;
  activeCategoryList.value = [];
  emit('toggle-menu');
};

const areLastChildren = computed(() => {
  return activeCategory.value?.children.every((child: any) => !child.children);
});
</script>
